import { usePathname } from 'next/navigation';
import React from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaXTwitter,
  FaYoutube,
} from 'react-icons/fa6';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
} from 'react-share';

function SocialShareIcons({ header = true }: { header?: boolean }) {
  const pathName = usePathname();
  // Safely get the full URL client-side
  const getFullUrl = () => {
    if (typeof window === 'undefined') return ''; // Server-side fallback
    return `${window.location.origin}${pathName}`;
  };

  const url = getFullUrl();

  return (
    <div className="post-content__social">
      {header && <h4>Share with:</h4>}

      <ul className="social social--style2">
        <li className="social__item">
          <FacebookShareButton
            url={url}
            hashtag="#YourBrand"
            className="social__link"
          >
            <FaFacebookF />
          </FacebookShareButton>
        </li>
        <li className="social__item">
          <a
            href="https://www.instagram.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="social__link"
          >
            <FaInstagram />
          </a>
        </li>
        <li className="social__item">
          <LinkedinShareButton url={url} className="social__link">
            <FaLinkedinIn />
          </LinkedinShareButton>
        </li>

        <li className="social__item">
          <TwitterShareButton url={url} className="social__link">
            <FaXTwitter />
          </TwitterShareButton>
        </li>
      </ul>
    </div>
  );
}

export default SocialShareIcons;
